// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"70":"0ee599a8d5fd952b","624":"2d5695cccf986c7e"}[chunkId] + ".css";
};